import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-向左",
  "use": "icon-向左-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-向左\">\r\n<style type=\"text/css\">\r\n</style>\r\n<path class=\"st0\" d=\"M0,100L200,0l-42.9,101.7L200,200L0,100z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol